import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { callServerLogout, clearAuthTokens } from "@/utils/auth";
import { socketManager } from "@/services/websocket/socket-manager";
import { setAuthChecked } from "@/store/slices/user.slice";
import { LOGOUT_USER_ACTION } from "@/utils/enums/auth.enums";

// Single source of truth for the full logout sequence — used by every auth path.
export const useAuthLogout = () => {
  const dispatch = useDispatch();

  return useCallback(async () => {
    await callServerLogout();
    clearAuthTokens();
    socketManager.disconnectAll();
    dispatch({ type: LOGOUT_USER_ACTION.NAME });
    dispatch(setAuthChecked(true));
  }, [dispatch]);
};
